export default[
    {
        path: '/collectMoney/memberLogout',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '会员销卡',
            keepAlive: false
        }
    }
]